export enum FundStatus {
  Open = 'open',
  Closed = 'closed',
  PartlyOpen = 'partly_open',
  Unknown = 'unknown',
}
